export default __webpack_public_path__ + "static/guidingPrinciples-63eeb4667aa01fceed0635bf3672ff66.svg";